import { parseStringValue } from "../parse-string-value.js";
export function enumField(enumValues, opts) {
    return (value) => {
        const res = parseStringValue(value, opts);
        if (!res.isValid || !res.value)
            return res;
        if (!enumValues.includes(res.value)) {
            return {
                isValid: false,
                error: opts.message,
            };
        }
        return {
            isValid: true,
            value: res.value,
        };
    };
}
